import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PageNavigation.css';

function PageNavigation() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const allPages = [
    { path: '/about', label: 'ABOUT' },
    { path: '/projects', label: 'PROJECTS' },
    { path: '/blog', label: 'BLOG' }
  ];

  // Check if we're on a blog post page
  const isBlogPost = currentPath.startsWith('/blog/') && currentPath !== '/blog';
  
  // Determine the effective path for navigation (blog posts should show BLOG as active)
  const effectivePath = isBlogPost ? '/blog' : currentPath;

  // Only show navigation on these pages
  if (!['/about', '/projects', '/blog'].includes(effectivePath)) {
    return null;
  }

  // Get the active page
  const activePage = allPages.find(page => page.path === effectivePath);
  const otherPages = allPages.filter(page => page.path !== effectivePath);

  // Reorder pages so active page is in the center (for desktop)
  const activeIndex = allPages.findIndex(page => page.path === effectivePath);
  const orderedPages = [
    allPages[(activeIndex + 1) % 3], // Left
    allPages[activeIndex],            // Center (active)
    allPages[(activeIndex + 2) % 3]   // Right
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav className="page-navigation">
        {/* Desktop view: show all three links */}
        {orderedPages.map((page, index) => {
          const isActive = effectivePath === page.path;
          const position = index === 0 ? 'left' : index === 1 ? 'center' : 'right';
          
          if (isActive) {
            return (
              <span key={page.path} className={`nav-link nav-link-${position} nav-link-active`}>
                {page.label}
              </span>
            );
          }
          
          return (
            <Link 
              key={page.path} 
              to={page.path} 
              className={`nav-link nav-link-${position}`}
            >
              {page.label}
            </Link>
          );
        })}

        {/* Mobile view: show only active page title and hamburger */}
        <div className="mobile-nav-header">
          <span className="mobile-nav-title nav-link-active">
            {activePage?.label}
          </span>
          <button 
            className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile menu dropdown */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        {otherPages.map((page) => (
          <Link 
            key={page.path} 
            to={page.path} 
            className="mobile-menu-link"
            onClick={closeMenu}
          >
            {page.label}
          </Link>
        ))}
      </div>
    </>
  );
}

export default PageNavigation;


